module.exports = __webpack_public_path__ + "static/img/icon-instagram.e3805862.png";